export default "__VITE_ASSET__DxotS_oN__"